import classNames from 'classnames'
import Cleave from 'cleave.js/react'
import _ from 'lodash'
import { FormFeedback, Label, UncontrolledTooltip } from 'reactstrap'

const InputNumber = (props) => {
    const { id, label, className, formik, maxLength, isRequired = false, isFormated = false, permission, onValueChange } = props
    const { values, errors, touched, handleChange, handleBlur } = formik ?? {}

    const value = _.get(values, id)
    const error = _.get(errors, id)
    const isTouched = _.get(touched, id)

    const options = {
        base: {
            numeral: true,
            numeralDecimalMark: '',
            delimiter: '',
            numeralPositiveOnly: true,
        },
        format: {
            numeral: true,
            numeralDecimalMark: ',',
            delimiter: '.',
            numeralPositiveOnly: true,
        },
    }

    return (
        <div className={className}>
            <Label htmlFor={id}>{label}</Label>
            {isRequired && <span className="required-mark">*</span>}
            {permission && (
                <>
                    {' '}
                    <span id={`agentPermissionsTooltip${permission.id}`}>
                        <i className="mdi mdi-help-circle-outline"></i>{' '}
                    </span>
                    <UncontrolledTooltip placement="right" target={`agentPermissionsTooltip${permission.id}`}>
                        {permission.description}
                    </UncontrolledTooltip>
                </>
            )}
            <Cleave
                id={id}
                name={id}
                onChange={(e) => {
                    handleChange(e)
                    onValueChange?.(e.target.value, formik)
                }}
                onBlur={handleBlur}
                value={value || ''}
                maxLength={maxLength ?? ``}
                options={isFormated ? options.format : options.base}
                className={classNames('form-control', {
                    'is-invalid': error && isTouched,
                })}
            />
            {error && isTouched ? <FormFeedback type="invalid">{error}</FormFeedback> : null}
        </div>
    )
}

export default InputNumber
